import { render, staticRenderFns } from "./btn-new-h5.vue?vue&type=template&id=e8a8c912&scoped=true"
import script from "./btn-new-h5.vue?vue&type=script&lang=js"
export * from "./btn-new-h5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a8c912",
  null
  
)

export default component.exports